// extracted by mini-css-extract-plugin
export default {"item":"AlarmOrMap_item__h45L3","map":"AlarmOrMap_map__CQU5P"};